var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumanIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_3406_33584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 16.7998C4 7.96325 11.1634 0.799805 20 0.799805C28.8366 0.799805 36 7.96325 36 16.7998C36 25.6364 28.8366 32.7998 20 32.7998C11.1634 32.7998 4 25.6364 4 16.7998Z",
    fill: "#2D6CDF",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3333 22.7998V21.4665C24.3333 20.7592 24.0524 20.081 23.5523 19.5809C23.0522 19.0808 22.3739 18.7998 21.6667 18.7998H17.6667C16.9594 18.7998 16.2811 19.0808 15.781 19.5809C15.281 20.081 15 20.7592 15 21.4665V22.7998",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6667 16.1331C21.1394 16.1331 22.3333 14.9392 22.3333 13.4665C22.3333 11.9937 21.1394 10.7998 19.6667 10.7998C18.1939 10.7998 17 11.9937 17 13.4665C17 14.9392 18.1939 16.1331 19.6667 16.1331Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_3406_33584",
    x: -1.78814e-7,
    y: -0.000195444,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1.6,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3406_33584"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3406_33584"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.8,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_3406_33584"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3406_33584",
    result: "effect2_dropShadow_3406_33584"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3406_33584",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanIcon);
export default __webpack_public_path__ + "static/media/humanIcon.bbc511c51afaf3e7fac1f0e46422495a.svg";
export { ForwardRef as ReactComponent };